export const NAZIONI = [
  {
    label: "AFGHANISTAN",
    value: "AF",
  },
  {
    label: "ALBANIA",
    value: "AL",
  },
  {
    label: "ALGERIA",
    value: "DZ",
  },
  {
    label: "ANDORRA",
    value: "AD",
  },
  {
    label: "ANGOLA",
    value: "AO",
  },
  {
    label: "ANGUILLA",
    value: "AI",
  },
  {
    label: "ANTARTIDE",
    value: "AQ",
  },
  {
    label: "ANTIGUAEBARBUDA",
    value: "AG",
  },
  {
    label: "ARABIASAUDITA",
    value: "SA",
  },
  {
    label: "ARGENTINA",
    value: "AR",
  },
  {
    label: "ARMENIA(Asia)",
    value: "AM",
  },
  {
    label: "ARMENIA(Europa)",
    value: "AM",
  },
  {
    label: "ARUBA",
    value: "AW",
  },
  {
    label: "AUSTRALIA",
    value: "AU",
  },
  {
    label: "AUSTRIA",
    value: "AT",
  },
  {
    label: "AZERBAIGIAN(Asia)",
    value: "AZ",
  },
  {
    label: "AZERBAIGIAN(Europa)",
    value: "AZ",
  },
  {
    label: "BAHAMAS",
    value: "BS",
  },
  {
    label: "BAHRAIN",
    value: "BH",
  },
  {
    label: "BANGLADESH",
    value: "BD",
  },
  {
    label: "BARBADOS",
    value: "BB",
  },
  {
    label: "BELGIO",
    value: "BE",
  },
  {
    label: "BELIZE",
    value: "BZ",
  },
  {
    label: "BENIN",
    value: "BJ",
  },
  {
    label: "BERMUDA",
    value: "BM",
  },
  {
    label: "BHUTAN",
    value: "BT",
  },
  {
    label: "BIELORUSSIA",
    value: "BY",
  },
  {
    label: "BIRMANIA",
    value: "MM",
  },
  {
    label: "BOLIVIA",
    value: "BO",
  },
  {
    label: "BOSNIAEDERZEGOVINA",
    value: "BA",
  },
  {
    label: "BOTSWANA",
    value: "BW",
  },
  {
    label: "BRASILE",
    value: "BR",
  },
  {
    label: "BRUNEI",
    value: "BN",
  },
  {
    label: "BULGARIA",
    value: "BG",
  },
  {
    label: "BURKINAFASO",
    value: "BF",
  },
  {
    label: "BURUNDI",
    value: "BI",
  },
  {
    label: "CAMBOGIA",
    value: "KH",
  },
  {
    label: "CAMERUN",
    value: "CM",
  },
  {
    label: "CANADA",
    value: "CA",
  },
  {
    label: "CAPOVERDE",
    value: "CV",
  },
  {
    label: "CIAD",
    value: "TD",
  },
  {
    label: "CILE",
    value: "CL",
  },
  {
    label: "CINAREPUBBLICANAZIONALE",
    value: "TW",
  },
  {
    label: "CINAREPUBBLICAPOPOLARE",
    value: "CN",
  },
  {
    label: "CIPRO",
    value: "CY",
  },
  {
    label: "CITTADELVATICANO",
    value: "VA",
  },
  {
    label: "COLOMBIA",
    value: "CO",
  },
  {
    label: "COMORE",
    value: "KM",
  },
  {
    label: "COREADELNORD",
    value: "KP",
  },
  {
    label: "COREADELSUD",
    value: "KR",
  },
  {
    label: "COSTADAVORIO",
    value: "CI",
  },
  {
    label: "COSTARICA",
    value: "CR",
  },
  {
    label: "CROAZIA",
    value: "HR",
  },
  {
    label: "CUBA",
    value: "CU",
  },
  {
    label: "CURACAO",
    value: "AN",
  },
  {
    label: "DANIMARCA",
    value: "DK",
  },
  {
    label: "DOMINICA",
    value: "DM",
  },
  {
    label: "ECUADOR",
    value: "EC",
  },
  {
    label: "EGITTO",
    value: "EG",
  },
  {
    label: "ELSALVADOR",
    value: "SV",
  },
  {
    label: "EMIRATIARABIUNITI",
    value: "AE",
  },
  {
    label: "ERITREA",
    value: "ER",
  },
  {
    label: "ESTONIA",
    value: "EE",
  },
  {
    label: "ETIOPIA",
    value: "ET",
  },
  {
    label: "FIGI",
    value: "Fj",
  },
  {
    label: "FILIPPINE",
    value: "PH",
  },
  {
    label: "FINLANDIA",
    value: "FI",
  },
  {
    label: "FRANCIA",
    value: "FR",
  },
  {
    label: "GABON",
    value: "GA",
  },
  {
    label: "GAMBIA",
    value: "GM",
  },
  {
    label: "GEORGIA",
    value: "GE",
  },
  {
    label: "GEORGIAD.SUDEI.SANDWICH",
    value: "GS",
  },
  {
    label: "GERMANIA",
    value: "DE",
  },
  {
    label: "GHANA",
    value: "GH",
  },
  {
    label: "GIAMAICA",
    value: "JM",
  },
  {
    label: "GIAPPONE",
    value: "JP",
  },
  {
    label: "GIBILTERRA",
    value: "GI",
  },
  {
    label: "GIBUTI",
    value: "DJ",
  },
  {
    label: "GIORDANIA",
    value: "JO",
  },
  {
    label: "GRECIA",
    value: "GR",
  },
  {
    label: "GRENADA",
    value: "GD",
  },
  {
    label: "GROENLANDIA",
    value: "GL",
  },
  {
    label: "GUADALUPA",
    value: "GP",
  },
  {
    label: "GUAM",
    value: "GU",
  },
  {
    label: "GUATEMALA",
    value: "GT",
  },
  {
    label: "GUERNSEY",
    value: "GG",
  },
  {
    label: "GUINEA",
    value: "GN",
  },
  {
    label: "GUINEAEQUATORIALE",
    value: "GQ",
  },
  {
    label: "GUINEA-BISSAU",
    value: "GW",
  },
  {
    label: "GUYANA",
    value: "GY",
  },
  {
    label: "GUYANAFRANCESE",
    value: "GF",
  },
  {
    label: "HAITI",
    value: "HT",
  },
  {
    label: "HONDURAS",
    value: "HN",
  },
  {
    label: "HONGKONG",
    value: "HK",
  },
  {
    label: "INDIA",
    value: "IN",
  },
  {
    label: "INDONESIA",
    value: "ID",
  },
  {
    label: "IRAN",
    value: "IR",
  },
  {
    label: "IRAQ",
    value: "IQ",
  },
  {
    label: "IRLANDA",
    value: "IE",
  },
  {
    label: "ISLANDA",
    value: "IS",
  },
  {
    label: "ISOLAALAND",
    value: "AX",
  },
  {
    label: "ISOLABOUVET",
    value: "BV",
  },
  {
    label: "ISOLADIMAN",
    value: "IM",
  },
  {
    label: "ISOLADINATALE",
    value: "CX",
  },
  {
    label: "ISOLANORFOLK",
    value: "NF",
  },
  {
    label: "ISOLEBES",
    value: "BQ",
  },
  {
    label: "ISOLECAYMAN",
    value: "KY",
  },
  {
    label: "ISOLECOCOSEKEELING",
    value: "CC",
  },
  {
    label: "ISOLECOOK",
    value: "CK",
  },
  {
    label: "ISOLEFAEROER",
    value: "FO",
  },
  {
    label: "ISOLEFALKLAND",
    value: "FK",
  },
  {
    label: "ISOLEHEARDEMCDONALD",
    value: "HM",
  },
  {
    label: "ISOLEMARIANNESETTENTRIONALI",
    value: "MP",
  },
  {
    label: "ISOLEMARSHALL",
    value: "MH",
  },
  {
    label: "ISOLEMINORIDEGLISTATIUNITI",
    value: "UM",
  },
  {
    label: "ISOLEPITCAIRN",
    value: "PN",
  },
  {
    label: "ISOLESALOMONE",
    value: "SB",
  },
  {
    label: "ISOLEVERGINIAMERICANE",
    value: "VI",
  },
  {
    label: "ISOLEVERGINIBRITANNICHE",
    value: "VG",
  },
  {
    label: "ISRAELE",
    value: "IL",
  },
  {
    label: "ITALIA",
    value: "IT",
  },
  {
    label: "JERSEY",
    value: "JE",
  },
  {
    label: "KAZAKISTAN(Asia)",
    value: "KZ",
  },
  {
    label: "KAZAKISTAN(Europa)",
    value: "KK",
  },
  {
    label: "KENYA",
    value: "KE",
  },
  {
    label: "KIRGHIZISTAN(Asia)",
    value: "KS",
  },
  {
    label: "KIRGHIZISTAN(Europa)",
    value: "KG",
  },
  {
    label: "KIRIBATI",
    value: "KI",
  },
  {
    label: "KOSOVO",
    value: "XZ",
  },
  {
    label: "KUWAIT",
    value: "KW",
  },
  {
    label: "LAOS",
    value: "LA",
  },
  {
    label: "LESOTHO",
    value: "LS",
  },
  {
    label: "LETTONIA",
    value: "LV",
  },
  {
    label: "LIBANO",
    value: "LB",
  },
  {
    label: "LIBERIA",
    value: "LR",
  },
  {
    label: "LIBIA",
    value: "LY",
  },
  {
    label: "LIECHTENSTEIN",
    value: "LI",
  },
  {
    label: "LITUANIA",
    value: "LT",
  },
  {
    label: "LUSSEMBURGO",
    value: "LU",
  },
  {
    label: "MACAO",
    value: "MO",
  },
  {
    label: "MADAGASCAR",
    value: "MG",
  },
  {
    label: "MALAWI",
    value: "MW",
  },
  {
    label: "MALDIVE",
    value: "MV",
  },
  {
    label: "MALESIA",
    value: "MY",
  },
  {
    label: "MALI",
    value: "ML",
  },
  {
    label: "MALTA",
    value: "MT",
  },
  {
    label: "MAROCCO",
    value: "MA",
  },
  {
    label: "MARTINICA",
    value: "MQ",
  },
  {
    label: "MAURITANIA",
    value: "MR",
  },
  {
    label: "MAURITIUS",
    value: "MU",
  },
  {
    label: "MAYOTTE",
    value: "YT",
  },
  {
    label: "MESSICO",
    value: "MX",
  },
  {
    label: "MICRONESIA",
    value: "FM",
  },
  {
    label: "MOLDAVIA",
    value: "MD",
  },
  {
    label: "MONGOLIA",
    value: "MN",
  },
  {
    label: "MONTENEGRO",
    value: "ME",
  },
  {
    label: "MONTSERRAT",
    value: "MS",
  },
  {
    label: "MOZAMBICO",
    value: "MZ",
  },
  {
    label: "NAMIBIA",
    value: "NA",
  },
  {
    label: "NAURU",
    value: "NR",
  },
  {
    label: "NEPAL",
    value: "NP",
  },
  {
    label: "NICARAGUA",
    value: "NI",
  },
  {
    label: "NIGER",
    value: "NE",
  },
  {
    label: "NIGERIA",
    value: "NG",
  },
  {
    label: "NIUE",
    value: "NU",
  },
  {
    label: "NORVEGIA",
    value: "NO",
  },
  {
    label: "NUOVACALEDONIA",
    value: "NC",
  },
  {
    label: "NUOVAZELANDA",
    value: "NZ",
  },
  {
    label: "OMAN",
    value: "OM",
  },
  {
    label: "PAESIBASSI",
    value: "NL",
  },
  {
    label: "PAKISTAN",
    value: "PK",
  },
  {
    label: "PALAU",
    value: "PW",
  },
  {
    label: "PALESTINA",
    value: "PS",
  },
  {
    label: "PANAMA",
    value: "PA",
  },
  {
    label: "PAPUANUOVAGUINEA",
    value: "PG",
  },
  {
    label: "PARAGUAY",
    value: "PY",
  },
  {
    label: "PERU",
    value: "PE",
  },
  {
    label: "POLINESIAFRANCESE",
    value: "PF",
  },
  {
    label: "POLONIA",
    value: "PL",
  },
  {
    label: "PORTORICO",
    value: "PR",
  },
  {
    label: "PORTOGALLO",
    value: "PT",
  },
  {
    label: "PRINCIPATODIMONACO",
    value: "MC",
  },
  {
    label: "QATAR",
    value: "QA",
  },
  {
    label: "REGNOUNITO",
    value: "GB",
  },
  {
    label: "REP.DEMOCRATICADELCONGO",
    value: "CD",
  },
  {
    label: "REP.DOMINICANA",
    value: "DO",
  },
  {
    label: "REPUBBLICACECA",
    value: "CZ",
  },
  {
    label: "REPUBBLICACENTRAFRICANA",
    value: "CF",
  },
  {
    label: "REPUBBLICADELCONGO",
    value: "CG",
  },
  {
    label: "REPUBBLICADIMACEDONIA",
    value: "MK",
  },
  {
    label: "RIUNIONE",
    value: "RE",
  },
  {
    label: "ROMANIA",
    value: "RO",
  },
  {
    label: "RUANDA",
    value: "RW",
  },
  {
    label: "RUSSIA",
    value: "RU",
  },
  {
    label: "SAHARAOCCIDENTALE",
    value: "EH",
  },
  {
    label: "SAINTKITTSENEVIS",
    value: "KN",
  },
  {
    label: "SAINTPIERREETMIQUELON",
    value: "PM",
  },
  {
    label: "SAINTVINCENTEGRENADINE",
    value: "VC",
  },
  {
    label: "SAINT-BARTHELEMY",
    value: "BL",
  },
  {
    label: "SAINT-MARTIN",
    value: "MF",
  },
  {
    label: "SAMOA",
    value: "WS",
  },
  {
    label: "SAMOAAMERICANE",
    value: "AS",
  },
  {
    label: "SANMARINO",
    value: "SM",
  },
  {
    label: "SANTALUCIA",
    value: "LC",
  },
  {
    label: "SANTELENA",
    value: "SH",
  },
  {
    label: "SAOTOMEEPRINCIPE",
    value: "ST",
  },
  {
    label: "SENEGAL",
    value: "SN",
  },
  {
    label: "SERBIA",
    value: "RS",
  },
  {
    label: "SEYCHELLES",
    value: "SC",
  },
  {
    label: "SIERRALEONE",
    value: "SL",
  },
  {
    label: "SINGAPORE",
    value: "SG",
  },
  {
    label: "SINTMAARTEN",
    value: "SX",
  },
  {
    label: "SIRIA",
    value: "SY",
  },
  {
    label: "SLOVACCHIA",
    value: "SK",
  },
  {
    label: "SLOVENIA",
    value: "SI",
  },
  {
    label: "SOMALIA",
    value: "SO",
  },
  {
    label: "SPAGNA",
    value: "ES",
  },
  {
    label: "SRILANKA",
    value: "LK",
  },
  {
    label: "STATIUNITIDAMERICA",
    value: "US",
  },
  {
    label: "SUDAFRICANA",
    value: "ZA",
  },
  {
    label: "SUDAN",
    value: "SD",
  },
  {
    label: "SUDANDELSUD",
    value: "SS",
  },
  {
    label: "SURINAME",
    value: "SR",
  },
  {
    label: "SVALBARDEJANMAYEN",
    value: "SJ",
  },
  {
    label: "SVEZIA",
    value: "SE",
  },
  {
    label: "SVIZZERA",
    value: "CH",
  },
  {
    label: "SWAZILAND",
    value: "SZ",
  },
  {
    label: "T.AUSTRALIEANT.FRANCESI",
    value: "TF",
  },
  {
    label: "T.BRITANNICODELLOCEANOIND.",
    value: "IO",
  },
  {
    label: "TAGIKISTAN(Asia)",
    value: "TJ",
  },
  {
    label: "TAGIKISTAN(Europa)",
    value: "TJ",
  },
  {
    label: "TAIWAN",
    value: "TW",
  },
  {
    label: "TANZANIA",
    value: "TZ",
  },
  {
    label: "RRITORIPALESTINESI",
    value: "TE",
  },
  {
    label: "THAILANDIA",
    value: "TH",
  },
  {
    label: "TIMOREST",
    value: "TP",
  },
  {
    label: "TOGO",
    value: "TG",
  },
  {
    label: "TOKELAU",
    value: "TK",
  },
  {
    label: "TONGA",
    value: "TO",
  },
  {
    label: "TRINIDADETOBAGO",
    value: "TT",
  },
  {
    label: "TUNISIA",
    value: "TN",
  },
  {
    label: "TURCHIA",
    value: "TR",
  },
  {
    label: "TURKMENISTAN(Asia)",
    value: "TM",
  },
  {
    label: "TURKMENISTAN(Europa)",
    value: "TM",
  },
  {
    label: "TURKSECAICOS",
    value: "TC",
  },
  {
    label: "TUVALU",
    value: "TV",
  },
  {
    label: "UCRAINA",
    value: "UA",
  },
  {
    label: "UGANDA",
    value: "UG",
  },
  {
    label: "UNGHERIA",
    value: "HU",
  },
  {
    label: "URUGUAY",
    value: "UY",
  },
  {
    label: "UZBEKISTAN",
    value: "UZ",
  },
  {
    label: "VANUATU",
    value: "VU",
  },
  {
    label: "VENEZUELA",
    value: "VE",
  },
  {
    label: "VIETNAM",
    value: "VN",
  },
  {
    label: "WALLISEFUTUNA",
    value: "WF",
  },
  {
    label: "YEMEN",
    value: "YE",
  },
  {
    label: "ZAMBIA",
    value: "ZM",
  },
  {
    label: "ZIMBAWE",
    value: "ZW",
  },
];
